import { render, staticRenderFns } from "./textarea_v.vue?vue&type=template&id=d2373916&scoped=true&"
import script from "./textarea_v.vue?vue&type=script&lang=js&"
export * from "./textarea_v.vue?vue&type=script&lang=js&"
import style0 from "./textarea_v.vue?vue&type=style&index=0&id=d2373916&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2373916",
  null
  
)

export default component.exports